import { Component, Input, Output, EventEmitter, Injectable, Inject, defineInjectable, inject, HostBinding, Directive, ComponentFactoryResolver, ViewContainerRef, NgModule } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { LoggerService, AngularMaterialModule, UtilsModule, ConsoleLoggerService } from 'utils';
import { __values } from 'tslib';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormComponent = /** @class */ (function () {
    function DynamicFormComponent(formBuilder, logger) {
        this.formBuilder = formBuilder;
        this.logger = logger;
        this.customEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DynamicFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logger.info('DynamicFormComponent: ngOnInit()');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DynamicFormComponent.prototype.onCustomEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logger.info('DynamicFormComponent: onCustomEvent()');
        this.customEvent.emit(event);
    };
    DynamicFormComponent.decorators = [
        { type: Component, args: [{
                    // encapsulation: ViewEncapsulation.None,
                    selector: 'dynamic-form',
                    template: "\n    <form  [autocomplete]=\"autocomplete\"\n           [className]=\"className\"\n           [formGroup]=\"formGroup\">\n\n      <ng-container *ngFor=\"let controlModel of formModel;\"\n                    dynamicControl [formGroup]=\"formGroup\"\n                    [model]=\"controlModel\"\n                    (customEvent)=\"onCustomEvent($event)\">\n      </ng-container>\n\n    </form>\n  ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicFormComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: LoggerService }
    ]; };
    DynamicFormComponent.propDecorators = {
        formGroup: [{ type: Input }],
        formModel: [{ type: Input, args: ['model',] }],
        autocomplete: [{ type: Input }],
        className: [{ type: Input }],
        customEvent: [{ type: Output }]
    };
    return DynamicFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DynamicFormsConfigService = 'Dynamic Forms Config';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormService = /** @class */ (function () {
    function DynamicFormService(config, formBuilder, httpClient, logger) {
        this.config = config;
        this.formBuilder = formBuilder;
        this.httpClient = httpClient;
        this.logger = logger;
        this.uriPrefix = 'assets/data/forms/';
        this.uriSuffix = '.json';
        this.getProperty = (/**
         * @param {?} obj
         * @param {?} path
         * @return {?}
         */
        function (obj, path) { return (path.split('.').reduce((/**
         * @param {?} o
         * @param {?} p
         * @return {?}
         */
        function (o, p) { return o && o[p]; }), obj)); });
        // this.url = this.url + this.config.defaultLanguage + '/';
        this.uriPrefix = this.uriPrefix + this.config.defaultLanguage.split('-')[0] + '/';
        this.logger.info('DynamicFormService: uriPrefrix: ' + this.uriPrefix);
    }
    /**
     * @param {?} formId
     * @return {?}
     */
    DynamicFormService.prototype.getFormMetadata = /**
     * @param {?} formId
     * @return {?}
     */
    function (formId) {
        return this.httpClient.get(this.uriPrefix + formId + this.uriSuffix);
    };
    // https://angular.io/api/forms/FormControl
    // https://angular.io/api/forms/FormControl
    /**
     * @param {?} formModel
     * @return {?}
     */
    DynamicFormService.prototype.createGroup = 
    // https://angular.io/api/forms/FormControl
    /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        var _this = this;
        /** @type {?} */
        var group = this.formBuilder.group({});
        this.logger.info('DynamicFormService: createGroup()');
        formModel.forEach((/**
         * @param {?} controlModel
         * @return {?}
         */
        function (controlModel) {
            /** @type {?} */
            var name = controlModel.id ? controlModel.id : controlModel.name;
            group.addControl(name, _this.createControl(controlModel));
        }));
        return group;
    };
    /**
     * @param {?} controlModel
     * @return {?}
     */
    DynamicFormService.prototype.createControl = /**
     * @param {?} controlModel
     * @return {?}
     */
    function (controlModel) {
        return this.formBuilder.control('', this.getValidators(controlModel.validators || []));
    };
    /**
     * @param {?} validatorModel
     * @return {?}
     */
    DynamicFormService.prototype.getValidators = /**
     * @param {?} validatorModel
     * @return {?}
     */
    function (validatorModel) {
        var _this = this;
        if (validatorModel.length === 0) {
            return null;
        }
        /** @type {?} */
        var functions = [];
        validatorModel.forEach((/**
         * @param {?} validator
         * @return {?}
         */
        function (validator) {
            functions.push(_this.getValidatorFn(validator.name, validator.args));
        }));
        return Validators.compose(functions);
    };
    /**
     * @param {?} validatorName
     * @param {?} validatorArgs
     * @return {?}
     */
    DynamicFormService.prototype.getValidatorFn = /**
     * @param {?} validatorName
     * @param {?} validatorArgs
     * @return {?}
     */
    function (validatorName, validatorArgs) {
        /** @type {?} */
        var validatorFn = null;
        //
        // Built-in validators: https://angular.io/guide/form-validation#built-in-validators
        //
        if (Validators.hasOwnProperty(validatorName)) {
            validatorFn = ((/** @type {?} */ (Validators)))[validatorName];
            if (validatorArgs !== null) {
                validatorFn = ((/** @type {?} */ (validatorFn)))(validatorArgs);
            }
            return validatorFn;
        }
    };
    /**
     * @param {?} formGroup
     * @param {?} item
     * @return {?}
     */
    DynamicFormService.prototype.initGroup = /**
     * @param {?} formGroup
     * @param {?} item
     * @return {?}
     */
    function (formGroup, item) {
        var e_1, _a;
        this.logger.info('DynamicFormService: initGroup()');
        try {
            for (var _b = __values(Object.keys(formGroup.controls)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                /** @type {?} */
                var property = this.getProperty(item, field);
                if (typeof property !== 'undefined') {
                    formGroup.controls[field].setValue(property);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    DynamicFormService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DynamicFormService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DynamicFormsConfigService,] }] },
        { type: FormBuilder },
        { type: HttpClient },
        { type: LoggerService }
    ]; };
    /** @nocollapse */ DynamicFormService.ngInjectableDef = defineInjectable({ factory: function DynamicFormService_Factory() { return new DynamicFormService(inject("Dynamic Forms Config"), inject(FormBuilder), inject(HttpClient), inject(LoggerService)); }, token: DynamicFormService, providedIn: "root" });
    return DynamicFormService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormControlModel = /** @class */ (function () {
    function DynamicFormControlModel(config) {
        this.type = config.type;
        this.id = config.id;
        this.inputType = config.inputType || 'text';
        this.appearance = config.appearance || 'outline';
        this.autocomplete = config.autocomplete || null;
        this.gridItemClass = config.gridItemClass || null;
        this.hideRequiredMarker = config.hideRequiredMarker || false;
        this.label = config.label || null;
        this.name = config.name || config.id;
        this.placeholder = config.placeholder || config.label;
        this.prefixIconName = config.prefixIconName || null;
        this.required = config.required || false;
        this.suffixIconName = config.suffixIconName || null;
        this.validators = config.validators || null;
    }
    return DynamicFormControlModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicDatepickerComponent = /** @class */ (function () {
    function DynamicDatepickerComponent(logger) {
        this.logger = logger;
    }
    /**
     * @return {?}
     */
    DynamicDatepickerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // this.logger.info('DynamicDatepickerComponent: ngOnInit()');
        this.elementClass = this.model.gridItemClass;
    };
    DynamicDatepickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'dynamic-datepicker',
                    template: "\n    <mat-form-field [appearance]=\"model.appearance\"\n                    [className]=\"model.gridItemClass\"\n                    [formGroup]=\"formGroup\">\n\n      <mat-label *ngIf=\"model.label\"> {{ model.label }} </mat-label>\n\n      <input #input matInput\n             [formControlName]=\"model.id\"\n             [matDatepicker]=\"picker\"\n             [placeholder]=\"model.placeholder\"\n             [required]=\"model.required\" />\n\n      <mat-icon matSuffix class=\"crm-suffix-icon\" (click)=\"picker.open()\"> event </mat-icon>\n\n      <mat-datepicker #picker></mat-datepicker>\n\n      <ng-container *ngFor=\"let validator of model.validators;\" ngProjectAs=\"mat-error\">\n        <mat-error *ngIf=\"formGroup.controls[model.id].hasError(validator.propertyName)\"> {{ validator.message }} </mat-error>\n      </ng-container>\n\n    </mat-form-field>\n  "
                }] }
    ];
    /** @nocollapse */
    DynamicDatepickerComponent.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    DynamicDatepickerComponent.propDecorators = {
        formGroup: [{ type: Input }],
        model: [{ type: Input }],
        elementClass: [{ type: HostBinding, args: ['class',] }]
    };
    return DynamicDatepickerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicInputComponent = /** @class */ (function () {
    function DynamicInputComponent(logger) {
        this.logger = logger;
        this.customEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DynamicInputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // this.logger.info('DynamicInputComponent: ngOnInit()');
        this.elementClass = this.model.gridItemClass;
    };
    /**
     * @return {?}
     */
    DynamicInputComponent.prototype.iconSuffixClickHandler = /**
     * @return {?}
     */
    function () {
        this.logger.info('DynamicInputComponent: emit customEvent');
        this.customEvent.emit({ type: 'click', id: this.model.id, directive: 'matSuffix', name: this.model.suffixIconName });
    };
    DynamicInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'dynamic-input',
                    template: "\n    <mat-form-field [appearance]=\"model.appearance\"\n                    [className]=\"model.gridItemClass\"\n                    [formGroup]=\"formGroup\">\n\n      <ng-container *ngIf=\"model.label\" ngProjectAs=\"mat-label\">\n        <mat-label> {{ model.label }} </mat-label>\n      </ng-container>\n\n      <span *ngIf=\"model.prefixIconName\" matPrefix>\n        <mat-icon matPrefix> {{ model.prefixIconName }} </mat-icon>\n      </span>\n\n      <input matInput\n             [autocomplete]=\"model.autocomplete\"\n             [formControlName]=\"model.id\"\n             [placeholder]=\"model.placeholder\"\n             [required]=\"model.required\"\n             [type]=\"model.inputType\"/>\n\n      <span *ngIf=\"model.suffixIconName\" matSuffix>\n        <mat-icon matSuffix class=\"crm-suffix-icon\" (click)=\"iconSuffixClickHandler()\"> {{ model.suffixIconName }} </mat-icon>\n      </span>\n\n      <ng-container *ngFor=\"let validator of model.validators;\" ngProjectAs=\"mat-error\">\n        <mat-error *ngIf=\"formGroup.controls[model.id].hasError(validator.propertyName)\"> {{ validator.message }} </mat-error>\n      </ng-container>\n\n    </mat-form-field>\n  "
                }] }
    ];
    /** @nocollapse */
    DynamicInputComponent.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    DynamicInputComponent.propDecorators = {
        formGroup: [{ type: Input }],
        model: [{ type: Input }],
        customEvent: [{ type: Output }],
        elementClass: [{ type: HostBinding, args: ['class',] }]
    };
    return DynamicInputComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var components = {
    date: DynamicDatepickerComponent,
    input: DynamicInputComponent
};
var DynamicControlDirective = /** @class */ (function () {
    function DynamicControlDirective(resolver, viewContainerRef, logger) {
        this.resolver = resolver;
        this.viewContainerRef = viewContainerRef;
        this.logger = logger;
        this.customEvent = new EventEmitter();
        this.componentSubscriptions = [];
    }
    /**
     * @return {?}
     */
    DynamicControlDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // this.logger.info('DynamicControlDirective: ngOnInit()');
        this.createDynamicFormControlComponent();
    };
    /**
     * @return {?}
     */
    DynamicControlDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.destroyDynamicFormControlComponent();
    };
    /**
     * @private
     * @return {?}
     */
    DynamicControlDirective.prototype.createDynamicFormControlComponent = /**
     * @private
     * @return {?}
     */
    function () {
        // this.logger.info('DynamicControlDirective: createDynamicFormControlComponent()');
        var _this = this;
        if (!components[this.model.type]) {
            /** @type {?} */
            var supportedTypes = Object.keys(components).join(', ');
            this.logger.info("You tried to use an unsupported type (" + this.model.type + "). Supported types: " + supportedTypes);
        }
        else {
            /** @type {?} */
            var factory = this.resolver.resolveComponentFactory(components[this.model.type]);
            this.componentRef = (/** @type {?} */ (this.viewContainerRef.createComponent(factory)));
            /** @type {?} */
            var instance = this.componentRef.instance;
            instance.formGroup = this.formGroup;
            instance.model = this.model;
            if (instance.customEvent !== undefined) {
                // this.logger.info('DynamicControlDirective: instance.customEvent.subscribe()');
                this.componentSubscriptions.push(instance.customEvent.subscribe((/**
                 * @param {?} event
                 * @return {?}
                 */
                function (event) { return _this.onCustomEvent(event); })));
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    DynamicControlDirective.prototype.destroyDynamicFormControlComponent = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.componentRef) {
            this.componentSubscriptions.forEach((/**
             * @param {?} subscription
             * @return {?}
             */
            function (subscription) {
                // this.logger.info('DynamicControlDirective: instance.customEvent.unsubscribe()');
                subscription.unsubscribe();
            }));
            this.componentSubscriptions = [];
            this.componentRef.destroy();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DynamicControlDirective.prototype.onCustomEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logger.info('DynamicControlDirective: onCustomEvent()');
        // const emitter = this.customEvent as EventEmitter<any>;
        // emitter.emit($event);
        this.customEvent.emit(event);
    };
    DynamicControlDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[dynamicControl]'
                },] }
    ];
    /** @nocollapse */
    DynamicControlDirective.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: ViewContainerRef },
        { type: LoggerService }
    ]; };
    DynamicControlDirective.propDecorators = {
        formGroup: [{ type: Input }],
        model: [{ type: Input }],
        customEvent: [{ type: Output }]
    };
    return DynamicControlDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormsModule = /** @class */ (function () {
    function DynamicFormsModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    DynamicFormsModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: DynamicFormsModule,
            providers: [
                { provide: DynamicFormsConfigService, useValue: config }
            ]
        };
    };
    DynamicFormsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        AngularMaterialModule,
                        CommonModule,
                        ReactiveFormsModule,
                        UtilsModule
                    ],
                    declarations: [
                        DynamicControlDirective,
                        DynamicFormComponent,
                        DynamicDatepickerComponent,
                        DynamicInputComponent
                    ],
                    providers: [
                        { provide: LoggerService, useClass: ConsoleLoggerService }
                    ],
                    exports: [
                        DynamicFormComponent
                    ],
                    entryComponents: [
                        DynamicDatepickerComponent,
                        DynamicInputComponent
                    ]
                },] }
    ];
    return DynamicFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DynamicFormComponent, DynamicFormControlModel, DynamicFormService, DynamicFormsModule, DynamicFormsConfigService as ɵa, DynamicControlDirective as ɵb, DynamicDatepickerComponent as ɵc, DynamicInputComponent as ɵd };
//# sourceMappingURL=dynamic-forms.js.map
